import React from "react";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import { dateToFullString, dateToString } from "utils/dateUtils";

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 65,
        paddingHorizontal: 20,
    },
    header: {
        flexDirection: "column",
        alignItems: "center",
        marginVertical: 10,
        justifyContent: "center",
    },
    image: {
        height: "4cm",
        width: "3cm",
        borderWidth: 1,
        borderColor: "lightgray",
        marginTop: 10,
    },
    title: {
        fontSize: 18,
        fontWeight: "bold",
    },
    divider: {
        width: "100%",
        height: 1,
        backgroundColor: "black",
        marginVertical: 10,
    },
    pageNumber: {
        position: "absolute",
        fontSize: 10,
        bottom: 30,
        left: 20,
        right: 20,
        textAlign: "right",
        color: "grey",
    },
    time: {
        position: "absolute",
        fontSize: 10,
        bottom: 30,
        left: 20,
        right: 20,
        textAlign: "left",
        color: "grey",
    },
    printedBy: {
        position: "absolute",
        fontSize: 10,
        bottom: 30,
        left: 10,
        right: 10,
        textAlign: "center",
        color: "grey",
    },
    footer: {
        position: "absolute",
        bottom: 40,
        left: 20,
        right: 20,
    },
    detail: {
        width: "100%",
    },
    memos: {
        marginTop: 30,
        borderWidth: 1,
        borderColor: "gray",
        width: "100%",
    },
    table: {
        tableHead: {
            flexDirection: "row",
            alignContent: "flex-start",
            borderBottomWidth: 1,
            borderBottomColor: "gray",
            padding: 2,
        },
        columnHeader: {
            fontSize: 10,
            fontWeight: "bold",
            fontStyle: "italic",
            flex: 1,
            textAlign: "left",
        },
        row: {
            flexDirection: "row",
            alignContent: "flex-start",
            borderBottomWidth: 1,
            borderBottomColor: "gray",
            padding: 2,
            minHeight: 20,
        },
        cell: {
            fontSize: 9,
            flex: 1,
            textAlign: "left",
        },
    },
    row: {
        marginTop: -1,
        flexDirection: "row",
        alignContent: "flex-start",
    },
    cell: {
        fontSize: 10,
        padding: 2,
        flex: 1,
        flexDirection: "row",
        textAlign: "left",
        marginLeft: -1,
        borderWidth: 1,
        borderColor: "gray",
    },
    cellKey: {
        fontWeight: "bold",
        fontSize: 12,
        alignSelf: "center",
    },
    cellValue: {
        marginLeft: 5,
        fontWeight: "normal",
        alignSelf: "center",
        color: "#555555",
    },
});

function getFormatedDate(dateInMillis) {
    return dateInMillis ? dateToString(new Date(dateInMillis), false) : "";
}

function generateModuleForm(personalInfo, formName) {
    if (formName === "Immigration") {
        return (
            <>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Arrival on:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.dateOfEntry)}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>At:</Text>
                        <Text style={styles.cellValue}>{personalInfo.placeOfEntry}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Type:</Text>
                        <Text style={styles.cellValue}>{personalInfo.type ? personalInfo.type.type : ""}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Name of Petitioner:</Text>
                        <Text style={styles.cellValue}>{personalInfo.petitioner}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>A#:</Text>
                        <Text style={styles.cellValue}>{personalInfo.petitionerANo}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>SSN:</Text>
                        <Text style={styles.cellValue}>{personalInfo.petitionerSSN}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Nat#:</Text>
                        <Text style={styles.cellValue}>{personalInfo.petitionerNatCert}</Text>
                    </View>
                </View>
            </>
        );
    }

    if (formName === "Taxes") {
        return <></>;
    }

    if (formName === "Injury") {
        return (
            <>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Type:</Text>
                        <Text style={styles.cellValue}>{personalInfo.type ? personalInfo.type.type : ""}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Other:</Text>
                        <Text style={styles.cellValue}>{personalInfo.other}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Insurance No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.insuranceNo}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Insurance Co.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.insuranceCo}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>DL No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.dlNo}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Policy No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.policyNo}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Insurer No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.insurerNo}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "40%" }}>
                        <Text style={styles.cellKey}>Date of Accident:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.dateOfAccident)}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "60%" }}>
                        <Text style={styles.cellKey}>Place of Accident:</Text>
                        <Text style={styles.cellValue}>{personalInfo.placeOfAccident}</Text>
                    </View>
                </View>
            </>
        );
    }

    if (formName === "Crime") {
        return (
            <>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Type:</Text>
                        <Text style={styles.cellValue}>{personalInfo.type ? personalInfo.type.type : ""}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Altern Contact:</Text>
                        <Text style={styles.cellValue}>{personalInfo.alternContact}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Case No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.caseNo}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>DL No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.dlNo}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Court No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.courtNo}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "40%" }}>
                        <Text style={styles.cellKey}>Court Date:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.courtDate)}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "60%" }}>
                        <Text style={styles.cellKey}>Location:</Text>
                        <Text style={styles.cellValue}>{personalInfo.location}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "40%" }}>
                        <Text style={styles.cellKey}>Date of Arrest:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.dateOfArrest)}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "60%" }}>
                        <Text style={styles.cellKey}>Place of Arrest:</Text>
                        <Text style={styles.cellValue}>{personalInfo.placeOfArrest}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Agency:</Text>
                        <Text style={styles.cellValue}>{personalInfo.agency}</Text>
                    </View>
                </View>
            </>
        );
    }

    if (formName === "Family") {
        return (
            <>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Type:</Text>
                        <Text style={styles.cellValue}>{personalInfo.type ? personalInfo.type.type : ""}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Respondent:</Text>
                        <Text style={styles.cellValue}>{personalInfo.respondent}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Respondent Address:</Text>
                        <Text style={styles.cellValue}>{personalInfo.respondentAddress}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "40%" }}>
                        <Text style={styles.cellKey}>Respondent DOB:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.respondentDob)}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "60%" }}>
                        <Text style={styles.cellKey}>Respondent SSN:</Text>
                        <Text style={styles.cellValue}>{personalInfo.respondentSsn}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Date of Marriage:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.dateOfMarriage)}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Date of Separation:</Text>
                        <Text style={styles.cellValue}>{personalInfo.dateOfSeparation}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Children:</Text>
                        <Text style={styles.cellValue}>{personalInfo.children}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "60%" }}>
                        <Text style={styles.cellKey}>Joint Property:</Text>
                        <Text style={styles.cellValue}>{personalInfo.jointProperty}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "40%" }}>
                        <Text style={styles.cellKey}>DL No.:</Text>
                        <Text style={styles.cellValue}>{personalInfo.dlNo}</Text>
                    </View>
                </View>
            </>
        );
    }
}

// Create Document Component
const MyDocument = ({ personalInfo, currentUser, photo, formName }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.header} fixed>
                <View>
                    <Text style={styles.title} fixed>
                        Client Information Sheet
                    </Text>
                </View>
                <View>{photo && <Image style={styles.image} src={photo} fixed />}</View>
            </View>

            <View style={styles.divider} fixed />

            <View style={styles.detail}>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>File #:</Text>
                        <Text style={styles.cellValue}>{personalInfo.fileNo}</Text>
                    </View>
                    {formName === "Immigration" && (
                        <View style={styles.cell}>
                            <Text style={styles.cellKey}>A#:</Text>
                            <Text style={styles.cellValue}>{personalInfo.alienRegistrationNo}</Text>
                        </View>
                    )}
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>SSN:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.ssn}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Start Date:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.startDate)}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "45%" }}>
                        <Text style={styles.cellKey}>Name:</Text>
                        <Text
                            style={styles.cellValue}
                        >{`${personalInfo.client.lastName}, ${personalInfo.client.firstName} ${personalInfo.client.middleName}`}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "25%" }}>
                        <Text style={styles.cellKey}>Ph#:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.homePhone}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "30%" }}>
                        <Text style={styles.cellKey}>Work Ph#:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.workPhone}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ ...styles.cell, flexBasis: "60%" }}>
                        <Text style={styles.cellKey}>Address:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.address}</Text>
                    </View>
                    <View style={{ ...styles.cell, flexBasis: "40%" }}>
                        <Text style={styles.cellKey}>City:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.city}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>State:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.state}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Zip:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.zipCode}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Reffered By:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.referredBy}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Date of Birth:</Text>
                        <Text style={styles.cellValue}>{getFormatedDate(personalInfo.client.birthDate)}</Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Country:</Text>
                        <Text style={styles.cellValue}>
                            {personalInfo.client && personalInfo.client.country ? personalInfo.client.country.name : ""}
                        </Text>
                    </View>
                    <View style={styles.cell}>
                        <Text style={styles.cellKey}>Place of Birth:</Text>
                        <Text style={styles.cellValue}>{personalInfo.client.birthPlace}</Text>
                    </View>
                </View>
                {generateModuleForm(personalInfo, formName)}
            </View>

            <View style={styles.memos}>
                <View style={styles.table.tableHead}>
                    <View style={{ ...styles.table.columnHeader, flexBasis: "20%" }}>
                        <Text>Date</Text>
                    </View>
                    <View style={{ ...styles.table.columnHeader, flexBasis: "80%" }}>
                        <Text>Memo</Text>
                    </View>
                </View>
                <View style={styles.table.row}>
                    <View style={{ ...styles.table.cell, flexBasis: "20%" }}>
                        <Text>{getFormatedDate(new Date().getTime())}</Text>
                    </View>
                    <View style={{ ...styles.table.cell, flexBasis: "80%" }}>
                        <Text>{personalInfo.notes}</Text>
                    </View>
                </View>
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
                <View style={styles.table.row} />
            </View>

            <View style={styles.footer} fixed>
                <View style={styles.divider} fixed />
            </View>

            <Text style={styles.time} render={() => dateToFullString(new Date())} fixed />

            <Text style={styles.printedBy} render={() => `Printed by ${currentUser.name}`} fixed />

            <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
        </Page>
    </Document>
);

export default MyDocument;
